import React from 'react'
import 'twin.macro'

import { TOTAL_QUESTION_COUNT } from 'constants/index'

interface ProgressBarProps {
  step: number
}

// https://www.creative-tim.com/learning-lab/tailwind-starter-kit/documentation/css/progressbars
const ProgressBar: React.FC<ProgressBarProps> = ({ step }) => {
  const progress = Math.round((step / TOTAL_QUESTION_COUNT) * 100)
  return (
    <div tw="relative">
      <div tw="flex mb-5 items-center justify-between">
        <div>
          <span tw="text-xs font-semibold inline-block py-5 px-7 uppercase rounded-full text-green-600 bg-green-200">
            step: {step}
          </span>
        </div>
        <div tw="text-right">
          <span tw="text-xs font-semibold inline-block text-green-600">
            {progress}%
          </span>
        </div>
      </div>
      <div tw="overflow-hidden h-2 mb-5 text-xs flex rounded bg-green-200">
        <div
          style={{ width: `${progress}%` }}
          tw="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-green-500"
        ></div>
      </div>
    </div>
  )
}

export default ProgressBar
